import { Money, PayoutSummary } from '@nemuru-eng/js-api-client';

import { amountToValueMoneyMapper } from '../../../../../../../../utils/mappers/amountToValueMoneyMapper';

export const usePayoutSummary = ({ payoutSummary }: { payoutSummary: PayoutSummary }) => {
  const currency = payoutSummary.disbursedAmount.currency;

  const sales: { quantity: number; amount: Money } = {
    quantity: payoutSummary.summary.sale?.number ? payoutSummary.summary.sale.number : 0,
    amount: payoutSummary.summary.sale?.totalAmount
      ? amountToValueMoneyMapper(payoutSummary.summary.sale.totalAmount)
      : { value: 0, currency },
  };

  const refunds: { quantity: number; amount: Money } = {
    quantity: payoutSummary.summary.refund?.number ? payoutSummary.summary.refund.number : 0,
    amount: payoutSummary.summary.refund?.totalAmount
      ? amountToValueMoneyMapper(payoutSummary.summary.refund.totalAmount)
      : { value: 0, currency },
  };

  const fixedFees: { quantity: number; amount: Money } = {
    quantity: payoutSummary.summary.fixedFee?.number ? payoutSummary.summary.fixedFee.number : 0,
    amount: payoutSummary.summary.fixedFee?.totalAmount
      ? amountToValueMoneyMapper(payoutSummary.summary.fixedFee.totalAmount)
      : { value: 0, currency },
  };

  const variableFees: { quantity: number; amount: Money } = {
    quantity: payoutSummary.summary.variableFee?.number ? payoutSummary.summary.variableFee.number : 0,
    amount: payoutSummary.summary.variableFee?.totalAmount
      ? amountToValueMoneyMapper(payoutSummary.summary.variableFee.totalAmount)
      : { value: 0, currency },
  };

  const vatOnFees: { rate: number; amount: Money } = {
    rate: payoutSummary.summary.vatOnFees?.vatRate ? payoutSummary.summary.vatOnFees.vatRate : 0,
    amount: payoutSummary.summary.vatOnFees?.totalVat
      ? amountToValueMoneyMapper(payoutSummary.summary.vatOnFees.totalVat)
      : { value: 0, currency },
  };

  const adjustments: { amount: Money } = {
    amount: payoutSummary.adjustmentsAmount
      ? amountToValueMoneyMapper(payoutSummary.adjustmentsAmount)
      : { value: 0, currency },
  };

  const vatOnAdjustments: { rate: number; amount: Money } = {
    rate: payoutSummary.summary.vatOnAdjustments?.vatRate ? payoutSummary.summary.vatOnAdjustments.vatRate : 0,
    amount: payoutSummary.summary.vatOnAdjustments?.totalVat
      ? amountToValueMoneyMapper(payoutSummary.summary.vatOnAdjustments.totalVat)
      : { value: 0, currency },
  };

  const total: { amount: Money } = {
    amount: {
      value:
        sales.amount.value +
        refunds.amount.value +
        fixedFees.amount.value +
        variableFees.amount.value +
        vatOnFees.amount.value +
        adjustments.amount.value +
        vatOnAdjustments.amount.value,
      currency,
    },
  };

  return { currency, sales, refunds, fixedFees, variableFees, vatOnFees, adjustments, vatOnAdjustments, total };
};
